"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferStepSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _OfferSkeleton = require("../OfferSkeleton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render skeleton for OfferStep which includes 4 OfferSkeletons.
 */
const OfferStepSkeleton = ({
  animation,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.OfferStepSkeleton),
    children: Array.from({
      length: 4
    }).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSkeleton.OfferSkeleton
    // eslint-disable-next-line react/no-array-index-key -- No other option for key
    , {
      animation: animation,
      className: className
    }, `offer-skeleton-${index}`))
  });
};
exports.OfferStepSkeleton = OfferStepSkeleton;